import Button from 'components/Form/Button';
import Breadcrumb from 'components/Navigation/Breadcrumb';
import React, { useState } from 'react';
import BankBeneficiaries from './Assets/BankBeneficiaries';
import { Link, useNavigate, useParams } from 'react-router-dom';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { createMarkup } from 'utils';
import RSABeneficiaries from './Assets/RSABeneficiaries';
import StocksBeneficiaries from './Assets/StocksBeneficiaries';
import EmployeeBeneficiaries from './Assets/EmployeeBeneficiaries';
import PhysicalBeneficiaries from './Assets/PhysicalBeneficiaries';
import BondBeneficiaries from './Assets/BondBeneficiaries';
import withCreatePortal from 'components/HOC/withCreatePortal';
import { useGetCustomerDetails } from 'common/queries-and-mutations/admin/customer';
import { Loader } from 'components/Loader';
import SuccessModal from 'components/Modal/SuccessModal';
import WillRejectModal from './WillRejectModal';
import { Icon, Icons } from 'components/Icon';
import UploadSignedWillModal from './UploadSignedWillModal';
import WillApprovalModal from './WillApprovalModal';

const EnhancedWillRejectModal = withCreatePortal(WillRejectModal);
const EnhancedWillApprovalModal = withCreatePortal(WillApprovalModal);
const EnhancedSuccessModal = withCreatePortal(SuccessModal);
const EnhancedUploadSignedWillModal = withCreatePortal(UploadSignedWillModal);

export default function CustomerWillSummary() {
  const { customerId } = useParams();
  const navigate = useNavigate();

  const [showSuccess, setShowSuccess] = useState(false);
  const [showReject, setShowReject] = useState(false);
  const [showApprove, setShowApprove] = useState(false);
  const [showUploadWill, setShowUploadWill] = useState(false);
  const [action, setAction] = useState('');
  const [showUploadSuccess, setShowUploadSuccess] = useState(false);

  const { data, isLoading, isFetched, refetch } = useGetCustomerDetails({
    customerId: +customerId!
  });

  if (isLoading && isFetched) {
    return (
      <div className="mt-40 flex flex-col items-center justify-center">
        <Loader color={'#FF6606'} height={50} width={50} />
      </div>
    );
  }

  return (
    <div>
      <div className="grid grid-cols-3">
        <div className="col-span-2 col-start-1">
          <Breadcrumb title="Customer’s Will Summary" />
        </div>
        <div className="col-span-1 col-start-7 col-end-7 flex items-center gap-5">
          <Link to={`/admin/customers/details/${customerId}`}>
            <Button
              variant="secondary"
              size="custom"
              className="h-5 w-[10rem] rounded-[3px] border-[#FF6600] bg-[#FF66061A] p-4 py-5 text-sm font-medium text-[#FF6606]"
              label="Customer's Profile"
              type="button"
            ></Button>
          </Link>
        </div>
      </div>

      <div className="mt-5 flex flex-col space-y-3 overflow-y-auto px-[var(--margin-x)] pb-20 transition-all duration-[.25s] scrollbar-hide md:h-[800px]">
        <BankBeneficiaries />
        <RSABeneficiaries />
        <StocksBeneficiaries />
        <EmployeeBeneficiaries />
        <PhysicalBeneficiaries />
        <BondBeneficiaries />
        {(data?.instructionDescription || data?.instructionTitle) && (
          <div className="mt-2 flex flex-col space-y-4">
            <div className="bg-white">
              <div className="border-b border-[#E5E5E5]">
                <p className="py-6 pl-10 font-bold text-[#34475E]">
                  {data?.instructionTitle}
                </p>
              </div>
              <div className="px-14 py-8">
                <p
                  dangerouslySetInnerHTML={createMarkup(
                    data?.instructionDescription
                  )}
                  className="text-[12px] font-[500] text-[#434343]"
                ></p>
              </div>
            </div>
          </div>
        )}

        {!!data?.sentForApproval && (
          <div className="flex items-center justify-end gap-5 pb-10 pt-5">
            <Button
              variant="secondary"
              size="custom"
              className="h-5 w-[10rem] rounded-[3px] border-[#E30000] bg-[#E30000] p-4 py-5 text-sm font-medium text-white"
              label="Reject Will"
              type="button"
              onClick={() => {
                setShowReject(true);
                setAction('Rejected');
              }}
            ></Button>

            <Button
              variant="secondary"
              size="custom"
              className="h-5 w-[10rem] rounded-[3px] border-[#00B388] bg-[#00B388] p-4 py-5 text-sm font-medium text-white"
              label="Approve Will"
              type="button"
              onClick={() => {
                setShowApprove(true);
                setAction('Approved');
              }}
            ></Button>
          </div>
        )}

        {data?.isAccountLocked === 1 && data?.sentForApproval === 0 && (
          <div className="flex items-center justify-end gap-5 pb-10 pt-5">
            <Button
              variant="secondary"
              size="custom"
              className="h-5 rounded-[3px] border-[#00B388] bg-[#00B388] px-3 py-6 text-sm font-medium text-white"
              label="Upload Signed Document"
              icon={
                <Icon
                  name={Icons.Upload}
                  width={20}
                  height={20}
                  fill="#FFFFFF"
                />
              }
              iconPosition="left"
              type="button"
              onClick={() => {
                setShowUploadWill(true);
              }}
            ></Button>
          </div>
        )}
      </div>

      {showSuccess && (
        <EnhancedSuccessModal
          title={`Customer Will Successfully ${action}`}
          onProccessClick={() => {
            setShowSuccess(false);
            setAction('');
          }}
          buttonText="Back to Customer"
        />
      )}
      {showUploadSuccess && (
        <EnhancedSuccessModal
          className="w-[25%]"
          title={`Signed will has been Uploaded Successfully`}
          onProccessClick={() => {
            setAction('');
            setShowUploadSuccess(false);
            navigate(`/admin/customers/details/${customerId}`);
          }}
          buttonText="Back to Customer"
        />
      )}
      {showReject && (
        <EnhancedWillRejectModal
          onSuccess={() => {
            setShowReject(false);
            setShowSuccess(true);
            refetch();
          }}
          onClose={() => setShowReject(false)}
          className="w-[30%]"
          customerId={+customerId!}
        />
      )}
      {showApprove && (
        <EnhancedWillApprovalModal
          onSuccess={() => {
            setShowApprove(false);
            setShowSuccess(true);
            refetch();
          }}
          onClose={() => setShowApprove(false)}
          customerId={+customerId!}
          className="w-[30%]"
          name={`${data?.othername} ${data?.surname}`}
        />
      )}
      {showUploadWill && (
        <EnhancedUploadSignedWillModal
          onSuccess={() => {
            setShowUploadWill(false);
            setShowUploadSuccess(true);
            refetch();
          }}
          onClose={() => setShowUploadWill(false)}
          className="w-[35%]"
          customerId={+customerId!}
          action={action}
        />
      )}
    </div>
  );
}
